import Community from "./pages/Community";
import Communities from "./pages/Communities";
import Section from "./pages/Section";
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Insights";
import Banking from "./pages/Banking";
import Member from "./pages/Member";
import Content from "./pages/Content";
import Material from "./pages/Material";
import CommunityConfig from "./pages/CommunityConfig";
import Mentoring from "./pages/Mentoring";
import SplitInvite from "./pages/SplitInvite";
import Components from "./pages/Components";
import FragmentsExamples from "./components/_fragments/examples";
import CardExamples from "./_examples/Cards";
import ScreenLayout from "Screen";

import { environment } from "./config";

const routes = {
  "": Communities,
  insights: Insights,
  dashboard: Dashboard,
  "/:slug": Community,

  ":slug/settings": CommunityConfig,
  ":slug/settings/:tab": CommunityConfig,
  ":slug/settings/:tab/:subtab": CommunityConfig,
  ":slug/settings/:tab/:subtab/:itemId": CommunityConfig,

  // Creator mentoring views (§6.11 + §6.10). The controller switches list↔detail
  // ↔attach off the :enrollmentId slot and the trailing /attach segment. The
  // public invite (mentoring/invite/:token, §6.9) is NOT registered here — it's a
  // public, shell-less route handled by App.js's AppRoutes branch (868jxkz4p §10).
  mentoring: Mentoring,
  "mentoring/:enrollmentId": Mentoring,
  "mentoring/:enrollmentId/attach": Mentoring,

  // Private split-invite landing (868k0v0ne §1). The invitee reaches this from
  // the email link app.ginastee.com/splitInvite/{token}; an unauthenticated
  // visitor is bounced to auth.ginastee.com by AuthContext and returned here,
  // so it's a normal authenticated route rendered inside the app shell — no
  // public-route infra (publicRoutes.js / App.js public branch) is touched. The
  // literal first segment `splitInvite` outranks the `/:slug` community route.
  "splitInvite/:token": SplitInvite,

  ":slug/section/:section": Section,
  ":slug/section/:section/:content": Content,

  ":slug/materials/:materialId": Material,

  banking: Banking,
  "banking/wallet": Banking,
  "banking/charges": Banking,
  "banking/subscriptions": Banking,
  "banking/anticipations": Banking,
  "banking/withdrawal": Banking,
  "banking/withdrawal/:action": Banking,
  "banking/chargebacks": Banking,
  "banking/chargebacks/:chargebackId": Banking,
  "user/:id": Member,
  components: Components,
  "components/cards": CardExamples,
  fragments: FragmentsExamples,

  'screen': ScreenLayout,
};

if (environment === "home") {
  routes["fragments"] = FragmentsExamples;
}

export default routes;
